import styled from 'styled-components';
import Button from '../../../../components/Button';
import { navUnderline } from '../../layouts/HeaderNav/styles';

export const StyledButton = styled(Button)`
  ${navUnderline}
  color: ${({ theme }) => theme.brand.headerText};
  padding: 0 0 6px;
  /* The shared Button is full-width (centred text) below 600px; size to content so it
     right-aligns with the other menu links */
  display: inline-block;
  width: auto;

  /* The shared Button nudges down 1px on press; keep Logout in line with the links */
  &:active {
    top: 0;
  }

  /* Balance the underline gap so Logout stays vertically centred in the desktop bar */
  ${({ theme }) => theme.media.desktopUp`
    padding: 6px 0;
  `}
`;
